import { ScreenScanPage } from '@hq/screen-scan';
import { hq } from '../session';

/**
 * 申请码确认（PC 端，GOV 门户）：
 * 输入大屏上显示的 12 位申请码（4-4-4 三段），当前登录账号直接确认；
 * 授权范围由令牌决定（本机构子树；跨机构账号可选全区）。
 */
export default function ScreenScan() {
  return <ScreenScanPage hq={hq} />;
}
